module.exports = __webpack_public_path__ + "static/media/zeiseler.79bf673e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeiseler.png
// module id = 25
// module chunks = 0